import { render } from "./ISTCView.vue?vue&type=template&id=40713cba"
import script from "./ISTCView.vue?vue&type=script&lang=js"
export * from "./ISTCView.vue?vue&type=script&lang=js"

import "./ISTCView.vue?vue&type=style&index=0&id=40713cba&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__